module.exports = __webpack_public_path__ + "static/2-10c7749946431ca0e96e58287863f83c.png";